import * as React from 'react';

import CertificateImage from 'bundles/accomplishments/components/shared/CertificateImage';

import _t from 'i18n!nls/certificate';

import 'css!./__styles__/S12nCertificate';

type Props = {
  s12nName: string;
  userName: string;
  certificateDescription: string;
  certificateLink: string;
  certificateImageUrl?: string;
  isCertificateOwner?: boolean;
};

class S12nCertificate extends React.Component<Props> {
  static defaultProps = {
    userName: _t('Jane Learner'),
  };

  render() {
    const { userName, s12nName, certificateDescription, certificateLink, certificateImageUrl, isCertificateOwner } =
      this.props;

    return (
      <div className="rc-S12nCertificate">
        <CertificateImage
          itemName={s12nName}
          certificateImageUrl={certificateImageUrl}
          certificatePdfPageLink={certificateLink}
          isCertificateOwner={isCertificateOwner}
          userName={userName}
          certificateDescription={certificateDescription}
          isSpecialization={true}
        />
      </div>
    );
  }
}

export default S12nCertificate;
